// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file api/gateway/v1/file.proto (package gateway.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/gateway/v1/file.proto.
 */
export const file_api_gateway_v1_file: GenFile = /*@__PURE__*/
  fileDesc("ChlhcGkvZ2F0ZXdheS92MS9maWxlLnByb3RvEgpnYXRld2F5LnYxIoYBCgRGaWxlEhEKCWZpbGVfdXVpZBgBIAEoCRIZChFpbnN0YWxsYXRpb25fdXVpZBgCIAEoCRIMCgRuYW1lGAMgASgJEhIKCm9iamVjdF9rZXkYBCABKAkSLgoKY3JlYXRlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiXAoWQ3JlYXRlVXBsb2FkVXJsUmVxdWVzdBIZChFpbnN0YWxsYXRpb25fdXVpZBgBIAEoCRIRCglmaWxlX25hbWUYAiABKAkSFAoMY29udGVudF90eXBlGAMgASgJIlYKF0NyZWF0ZVVwbG9hZFVybFJlc3BvbnNlEgsKA3VybBgBIAEoCRIuCgpleHBpcmVzX2F0GAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCJ/ChVDb21wbGV0ZVVwbG9hZFJlcXVlc3QSEgoKb2JqZWN0X2tleRgBIAEoCRISCgpzaXplX2J5dGVzGAIgASgDEhAKCGNoZWNrc3VtGAMgASgJEhEKCWZpbGVfbmFtZRgEIAEoCRIZChFpbnN0YWxsYXRpb25fdXVpZBgFIAEoCSI4ChZDb21wbGV0ZVVwbG9hZFJlc3BvbnNlEh4KBGZpbGUYASABKAsyEC5nYXRld2F5LnYxLkZpbGUiLQoYQ3JlYXRlRG93bmxvYWRVcmxSZXF1ZXN0EhEKCWZpbGVfdXVpZBgBIAEoCSJYChlDcmVhdGVEb3dubG9hZFVybFJlc3BvbnNlEgsKA3VybBgBIAEoCRIuCgpleHBpcmVzX2F0GAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCI+CiFHZXRGaWxlc0J5SW5zdGFsbGF0aW9uVXVpZFJlcXVlc3QSGQoRaW5zdGFsbGF0aW9uX3V1aWQYASABKAkiRQoiR2V0RmlsZXNCeUluc3RhbGxhdGlvblV1aWRSZXNwb25zZRIfCgVmaWxlcxgBIAMoCzIQLmdhdGV3YXkudjEuRmlsZSImChFEZWxldGVGaWxlUmVxdWVzdBIRCglmaWxlX3V1aWQYASABKAkiFAoSRGVsZXRlRmlsZVJlc3BvbnNlMu4DCgtGaWxlU2VydmljZRJaCg9DcmVhdGVVcGxvYWRVcmwSIi5nYXRld2F5LnYxLkNyZWF0ZVVwbG9hZFVybFJlcXVlc3QaIy5nYXRld2F5LnYxLkNyZWF0ZVVwbG9hZFVybFJlc3BvbnNlElcKDkNvbXBsZXRlVXBsb2FkEiEuZ2F0ZXdheS52MS5Db21wbGV0ZVVwbG9hZFJlcXVlc3QaIi5nYXRld2F5LnYxLkNvbXBsZXRlVXBsb2FkUmVzcG9uc2USYAoRQ3JlYXRlRG93bmxvYWRVcmwSJC5nYXRld2F5LnYxLkNyZWF0ZURvd25sb2FkVXJsUmVxdWVzdBolLmdhdGV3YXkudjEuQ3JlYXRlRG93bmxvYWRVcmxSZXNwb25zZRJ7ChpHZXRGaWxlc0J5SW5zdGFsbGF0aW9uVXVpZBItLmdhdGV3YXkudjEuR2V0RmlsZXNCeUluc3RhbGxhdGlvblV1aWRSZXF1ZXN0Gi4uZ2F0ZXdheS52MS5HZXRGaWxlc0J5SW5zdGFsbGF0aW9uVXVpZFJlc3BvbnNlEksKCkRlbGV0ZUZpbGUSHS5nYXRld2F5LnYxLkRlbGV0ZUZpbGVSZXF1ZXN0Gh4uZ2F0ZXdheS52MS5EZWxldGVGaWxlUmVzcG9uc2VCZAoOY29tLmdhdGV3YXkudjFCCUZpbGVQcm90b1ABogIDR1hYqgIKR2F0ZXdheS5WMcoCCkdhdGV3YXlcVjHiAhZHYXRld2F5XFYxXEdQQk1ldGFkYXRh6gILR2F0ZXdheTo6VjFiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * File represents the information of the file
 *
 * @generated from message gateway.v1.File
 */
export type File = Message<"gateway.v1.File"> & {
  /**
   * file_uuid is the unique identifier for the file
   *
   * @generated from field: string file_uuid = 1;
   */
  fileUuid: string;

  /**
   * installation_uuid is the unique identifier of the installation the file is associated to
   *
   * @generated from field: string installation_uuid = 2;
   */
  installationUuid: string;

  /**
   * name is the display name of the file.
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * object_key is the path of the file inside the bucket.
   *
   * @generated from field: string object_key = 4;
   */
  objectKey: string;

  /**
   * created_at timestamp when the file was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message gateway.v1.File.
 * Use `create(FileSchema)` to create a new message.
 */
export const FileSchema: GenMessage<File> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_file, 0);

/**
 * -----------------------------
 * File Upload
 * -----------------------------
 *
 * @generated from message gateway.v1.CreateUploadUrlRequest
 */
export type CreateUploadUrlRequest = Message<"gateway.v1.CreateUploadUrlRequest"> & {
  /**
   * @generated from field: string installation_uuid = 1;
   */
  installationUuid: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * @generated from field: string content_type = 3;
   */
  contentType: string;
};

/**
 * Describes the message gateway.v1.CreateUploadUrlRequest.
 * Use `create(CreateUploadUrlRequestSchema)` to create a new message.
 */
export const CreateUploadUrlRequestSchema: GenMessage<CreateUploadUrlRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_file, 1);

/**
 * @generated from message gateway.v1.CreateUploadUrlResponse
 */
export type CreateUploadUrlResponse = Message<"gateway.v1.CreateUploadUrlResponse"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 2;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * Describes the message gateway.v1.CreateUploadUrlResponse.
 * Use `create(CreateUploadUrlResponseSchema)` to create a new message.
 */
export const CreateUploadUrlResponseSchema: GenMessage<CreateUploadUrlResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_file, 2);

/**
 * -----------------------------
 * File Upload completion
 * -----------------------------
 *
 * @generated from message gateway.v1.CompleteUploadRequest
 */
export type CompleteUploadRequest = Message<"gateway.v1.CompleteUploadRequest"> & {
  /**
   * @generated from field: string object_key = 1;
   */
  objectKey: string;

  /**
   * @generated from field: int64 size_bytes = 2;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: string checksum = 3;
   */
  checksum: string;

  /**
   * @generated from field: string file_name = 4;
   */
  fileName: string;

  /**
   * @generated from field: string installation_uuid = 5;
   */
  installationUuid: string;
};

/**
 * Describes the message gateway.v1.CompleteUploadRequest.
 * Use `create(CompleteUploadRequestSchema)` to create a new message.
 */
export const CompleteUploadRequestSchema: GenMessage<CompleteUploadRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_file, 3);

/**
 * @generated from message gateway.v1.CompleteUploadResponse
 */
export type CompleteUploadResponse = Message<"gateway.v1.CompleteUploadResponse"> & {
  /**
   * @generated from field: gateway.v1.File file = 1;
   */
  file?: File | undefined;
};

/**
 * Describes the message gateway.v1.CompleteUploadResponse.
 * Use `create(CompleteUploadResponseSchema)` to create a new message.
 */
export const CompleteUploadResponseSchema: GenMessage<CompleteUploadResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_file, 4);

/**
 * -----------------------------
 * File Download
 * -----------------------------
 *
 * @generated from message gateway.v1.CreateDownloadUrlRequest
 */
export type CreateDownloadUrlRequest = Message<"gateway.v1.CreateDownloadUrlRequest"> & {
  /**
   * @generated from field: string file_uuid = 1;
   */
  fileUuid: string;
};

/**
 * Describes the message gateway.v1.CreateDownloadUrlRequest.
 * Use `create(CreateDownloadUrlRequestSchema)` to create a new message.
 */
export const CreateDownloadUrlRequestSchema: GenMessage<CreateDownloadUrlRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_file, 5);

/**
 * @generated from message gateway.v1.CreateDownloadUrlResponse
 */
export type CreateDownloadUrlResponse = Message<"gateway.v1.CreateDownloadUrlResponse"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 2;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * Describes the message gateway.v1.CreateDownloadUrlResponse.
 * Use `create(CreateDownloadUrlResponseSchema)` to create a new message.
 */
export const CreateDownloadUrlResponseSchema: GenMessage<CreateDownloadUrlResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_file, 6);

/**
 * -----------------------------
 * Get Files by installation
 * -----------------------------
 *
 * @generated from message gateway.v1.GetFilesByInstallationUuidRequest
 */
export type GetFilesByInstallationUuidRequest = Message<"gateway.v1.GetFilesByInstallationUuidRequest"> & {
  /**
   * @generated from field: string installation_uuid = 1;
   */
  installationUuid: string;
};

/**
 * Describes the message gateway.v1.GetFilesByInstallationUuidRequest.
 * Use `create(GetFilesByInstallationUuidRequestSchema)` to create a new message.
 */
export const GetFilesByInstallationUuidRequestSchema: GenMessage<GetFilesByInstallationUuidRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_file, 7);

/**
 * @generated from message gateway.v1.GetFilesByInstallationUuidResponse
 */
export type GetFilesByInstallationUuidResponse = Message<"gateway.v1.GetFilesByInstallationUuidResponse"> & {
  /**
   * @generated from field: repeated gateway.v1.File files = 1;
   */
  files: File[];
};

/**
 * Describes the message gateway.v1.GetFilesByInstallationUuidResponse.
 * Use `create(GetFilesByInstallationUuidResponseSchema)` to create a new message.
 */
export const GetFilesByInstallationUuidResponseSchema: GenMessage<GetFilesByInstallationUuidResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_file, 8);

/**
 * -----------------------------
 * Delete file by file_uuid
 * -----------------------------
 *
 * @generated from message gateway.v1.DeleteFileRequest
 */
export type DeleteFileRequest = Message<"gateway.v1.DeleteFileRequest"> & {
  /**
   * @generated from field: string file_uuid = 1;
   */
  fileUuid: string;
};

/**
 * Describes the message gateway.v1.DeleteFileRequest.
 * Use `create(DeleteFileRequestSchema)` to create a new message.
 */
export const DeleteFileRequestSchema: GenMessage<DeleteFileRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_file, 9);

/**
 * @generated from message gateway.v1.DeleteFileResponse
 */
export type DeleteFileResponse = Message<"gateway.v1.DeleteFileResponse"> & {
};

/**
 * Describes the message gateway.v1.DeleteFileResponse.
 * Use `create(DeleteFileResponseSchema)` to create a new message.
 */
export const DeleteFileResponseSchema: GenMessage<DeleteFileResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_file, 10);

/**
 * -------------------------------------------------------------------------
 * File CRUD operations
 * -------------------------------------------------------------------------
 *
 * @generated from service gateway.v1.FileService
 */
export const FileService: GenService<{
  /**
   * Request a pre-signed URL to upload a file
   *
   * @generated from rpc gateway.v1.FileService.CreateUploadUrl
   */
  createUploadUrl: {
    methodKind: "unary";
    input: typeof CreateUploadUrlRequestSchema;
    output: typeof CreateUploadUrlResponseSchema;
  },
  /**
   * Confirm upload completed (store metadata, validate object exists)
   *
   * @generated from rpc gateway.v1.FileService.CompleteUpload
   */
  completeUpload: {
    methodKind: "unary";
    input: typeof CompleteUploadRequestSchema;
    output: typeof CompleteUploadResponseSchema;
  },
  /**
   * Request a pre-signed URL to download a file
   *
   * @generated from rpc gateway.v1.FileService.CreateDownloadUrl
   */
  createDownloadUrl: {
    methodKind: "unary";
    input: typeof CreateDownloadUrlRequestSchema;
    output: typeof CreateDownloadUrlResponseSchema;
  },
  /**
   * Request all the files from an installation
   *
   * @generated from rpc gateway.v1.FileService.GetFilesByInstallationUuid
   */
  getFilesByInstallationUuid: {
    methodKind: "unary";
    input: typeof GetFilesByInstallationUuidRequestSchema;
    output: typeof GetFilesByInstallationUuidResponseSchema;
  },
  /**
   * Request the deletion of a file from the s3
   *
   * @generated from rpc gateway.v1.FileService.DeleteFile
   */
  deleteFile: {
    methodKind: "unary";
    input: typeof DeleteFileRequestSchema;
    output: typeof DeleteFileResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_gateway_v1_file, 0);

